var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAttentionTriangle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.486 6.81909C20.6977 3.77905 16.3013 3.77905 14.5131 6.81909L4.48737 23.8628C2.67373 26.946 4.89677 30.8328 8.47382 30.8328H28.5252C32.1023 30.8328 34.3253 26.946 32.5117 23.8628L22.486 6.81909ZM16.958 20.0411V10.7911H20.0413V20.0411H16.958ZM16.958 23.1245V25.437H20.0413V23.1245H16.958Z",
    fill: "#FFB700"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAttentionTriangle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_attention_triangle.d56f94ede40c6fefd74e8e819a442896.svg";